import { render, staticRenderFns } from "./AddNewSkillPopup.vue?vue&type=template&id=71ff1628"
import script from "./AddNewSkillPopup.vue?vue&type=script&lang=ts"
export * from "./AddNewSkillPopup.vue?vue&type=script&lang=ts"
import style0 from "./AddNewSkillPopup.vue?vue&type=style&index=0&id=71ff1628&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports